import { render, staticRenderFns } from "./kyb.vue?vue&type=template&id=64b8e78b&scoped=true"
import script from "./kyb.vue?vue&type=script&lang=js"
export * from "./kyb.vue?vue&type=script&lang=js"
import style0 from "./kyb.vue?vue&type=style&index=0&id=64b8e78b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8e78b",
  null
  
)

export default component.exports